import { type WorkspaceAgentPanelView } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentPanelView';
import { WORKSPACE_AGENT_DEFAULT_SESSION_TITLE } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

export const WORKSPACE_AGENT_PANEL_MY_TASKS_HEADER_TITLE = 'My tasks';

export type WorkspaceAgentPanelHeaderDisplayTitleInput = {
  panelView: WorkspaceAgentPanelView;
  sessionId: string | null;
  sessionTitle: string;
};

export const getWorkspaceAgentPanelHeaderDisplayTitle = ({
  panelView,
  sessionId,
  sessionTitle,
}: WorkspaceAgentPanelHeaderDisplayTitleInput): string => {
  if (panelView === 'tasks') {
    return WORKSPACE_AGENT_PANEL_MY_TASKS_HEADER_TITLE;
  }

  if (!sessionId) {
    return WORKSPACE_AGENT_DEFAULT_SESSION_TITLE;
  }

  return sessionTitle.trim() || WORKSPACE_AGENT_DEFAULT_SESSION_TITLE;
};
